const map = new Map()

/**
 * Makes any reference immutable by adding it to a map with a given key.
 * If the item already exists in the map, it returns the existing item.
 * Otherwise, it adds the item to the map and returns it.
 *
 * @param {any} key - The key used to identify the item in the map.
 * @param {T} sub - The item to make immutable.
 * @returns {T} - The item.
 */
export function makeOnce<T>(key: any, sub: T): T {
  if (map.get(key)) {
    return map.get(key)
  }
  map.set(key, sub)
  return sub
}
